export type FileDataTuple = [string, string]

export const getFileNameExtension = (filename: string): FileDataTuple => {
  if (!filename) return ['', '']

  const name = filename.substring(0, filename.lastIndexOf('.'))
  const ext = filename.split('.').pop()

  return [name, ext ?? '']
}

export const renameFile = (file: File, newName: string): File => {
  return new File([file], newName, {
    type: file.type || getMimeType(newName),
    lastModified: file.lastModified
  })
}

export const fileFromBase64String = (
  base64String: string,
  filename: string,
  mimeType: string
): File => {
  const byteArray = Uint8Array.from(
    atob(base64String.split(',')[1])
      .split('')
      .map((char) => char.charCodeAt(0))
  )
  return new File([byteArray], filename, { type: mimeType })
}

export const isFileValid = (file: File, validExtensions: string[]): boolean => {
  const [, extension] = getFileNameExtension(file.name)
  return (
    validExtensions.findIndex(
      (ext) => ext.toLowerCase() === `.${extension.toLowerCase()}`
    ) !== -1
  )
}

export const getTotalSizeFiles = (files: File[]): number => {
  let totalSize = 0
  for (const fileIndex in files) {
    totalSize += files[fileIndex].size
  }

  return totalSize
}

export const getMimeType = (filename: string): string => {
  const [, extension] = getFileNameExtension(filename)

  switch (extension.toLowerCase()) {
    case 'docx':
      return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    case 'doc':
      return 'application/msword'
    case 'rtf':
      return 'application/rtf'
    case 'wpd':
      return 'application/wordperfect'
    case 'pdf':
      return 'application/pdf'
    case 'txt':
      return 'text/plain'
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg'
    case 'png':
      return 'image/png'
    case 'gif':
      return 'image/gif'
    case 'bmp':
      return 'image/bmp'
  }
  return ''
}

// Taken from: https://dev.to/nombrekeff/download-file-from-blob-21ho
export const downloadBlob = (blob: Blob, name = 'file.pdf'): void => {
  // Convert your blob into a Blob URL (a special url that points to an object in the browser's memory)
  const blobUrl = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = blobUrl
  link.download = name

  document.body.appendChild(link)

  link.dispatchEvent(
    new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    })
  )

  document.body.removeChild(link)
  setTimeout(() => {
    // For Firefox it is necessary to delay revoking the ObjectURL
    URL.revokeObjectURL(blobUrl)
  }, 100)
}
